module.exports = fox._r("images/fancybox.png", __webpack_public_path__ + "images/fancybox.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/fancybox.png
// module id = 1041
// module chunks = 4